export const getChecklistTableMessage = (
	error,
	checklists,
	customerID,
	addressID,
	pending,
) => {
	if (pending) {
		return <h1>Loading...</h1>;
	}
	if (error) {
		return <h1>Error! Something went wrong</h1>;
	}
	if (checklists.length > 0) {
		return <h1>No results found</h1>;
	}
	if (customerID === '0') {
		return (
			<h1>
				No Global Checklist Added. <br />
				Click '+ Checklist' to get started.
			</h1>
		);
	}
	if (customerID === '' && addressID === '') {
		return <h1> Select company and an address to get started</h1>;
	}
	if (customerID !== '' && addressID === '') {
		return <h1> Choose an address for the selected company</h1>;
	}
	if (checklists.length === 0) {
		return (
			<h1>
				No checklist added for this location.
				<br />
				Click '+ Checklist' to get started.
			</h1>
		);
	}
	return <h1>Unexpected error. Please try refreshing the page.</h1>;
};
